import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`w100`)
}
const _hoisted_3 = {
  key: 0,
  class: "mt20"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "mt20"
}
const _hoisted_6 = { class: "fl fw600 fs12 mt4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fw600 fs14 mt40" }, [
  /*#__PURE__*/_createTextVNode(" カスタム通知設定 "),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "mt20"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "fr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_CustomMailFlowList = _resolveComponent("CustomMailFlowList")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_MailEditDetailContent = _resolveComponent("MailEditDetailContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.rcm.room)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            (_ctx.rcm.room.room_type == `parent_room`)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.selectedTabName == 'create_room' ? 'selected fw600' : ''
                    }`),
                  style: {"width":"33%"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategoryTab('create_room')))
                }, " 初回 ", 2))
              : _createCommentVNode("", true),
            (_ctx.rcm.room.room_type == `public_room`)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.selectedTabName == 'inquire_on_public_room' && !_ctx.showSwitchers ? 'selected fw600' : ''
                    }`),
                  style: {
                        width: `33%`,
                    },
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategoryTab('inquire_on_public_room')))
                }, " 完了時 ", 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        [`fixed_appointment`, `fix`].includes(_ctx.selectedTabName) && !_ctx.showSwitchers ? 'selected fw600' : ''
                    }`),
              style: _normalizeStyle({
                        width: `${_ctx.rcm.room.room_type == `parent_room` ? `33%` : `33%`}`,
                    }),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCategoryTab('fixed_appointment')))
            }, " 確定時 ", 6),
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        ![`create_room`, `inquire_on_public_room`, `fix`, `fixed_appointment`].includes(_ctx.selectedTabName)
                            ? 'selected fw600'
                            : ''
                    }`),
              style: _normalizeStyle({
                        width: `${_ctx.rcm.room.room_type == `parent_room` ? `33%` : `33%`}`,
                    }),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectCategoryTab('settings')))
            }, " 送信設定 ", 6)
          ]))
        : _createCommentVNode("", true),
      _hoisted_4,
      (_ctx.showSwitchers && _ctx.sendTimingArray)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sendTimingArray, (timing, timingindex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(`w100 pad5 ${timingindex % 2 == 0 ? `llgreyBg` : ``}`),
                style: {"height":"60px"},
                key: timingindex
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(timing.name), 1),
                _createVNode(_component_Switcher, {
                  value: "type[active]",
                  name: "無効",
                  checked: timing.is_active,
                  display: "true",
                  class: "checkUsingCal fr",
                  onSelect: ($event: any) => (_ctx.changeActive(timing))
                }, null, 8, ["checked", "onSelect"]),
                _createElementVNode("span", {
                  class: "circle_button fr skyblueBg rad4 fs11 mt2 mr10",
                  style: {"padding":"4px 8px"},
                  onClick: ($event: any) => (_ctx.editContent(timing))
                }, " 編集 ", 8, _hoisted_7),
                _createElementVNode("span", {
                  class: "fr skyblue rad4 fs11 mt2 mr10 pointer",
                  style: {"padding":"4px 8px"},
                  onClick: ($event: any) => (_ctx.showPreview(timing))
                }, " プレビュー ", 8, _hoisted_8),
                _hoisted_9
              ], 2))
            }), 128)),
            _hoisted_10,
            (_ctx.rm.canUseOption(`room_custom_mail_flows`, false))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_ctx.customMailFlows.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customMailFlows, (mf, mfindex) => {
                          return (_openBlock(), _createElementBlock("div", { key: mfindex }, [
                            _createVNode(_component_CustomMailFlowList, {
                              mf: mf,
                              mfindex: mfindex,
                              onEditContent: _ctx.editContent,
                              onRemoveCustomMf: _ctx.removeCustomMf
                            }, null, 8, ["mf", "mfindex", "onEditContent", "onRemoveCustomMf"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13)),
            _createElementVNode("div", {
              class: "w100 pad10 circle_button blueAround rad8 mt20 centered fw600",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addCustomMailFlow && _ctx.addCustomMailFlow(...args)))
            }, [
              _createTextVNode(" カスタム通知を追加 "),
              (!_ctx.rm.canUseOption(`room_custom_mail_flows`, false))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_IconLock, {
                      style: {},
                      class: "",
                      width: 16
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_ctx.rcm.selectedMailFlow)
          ? (_openBlock(), _createElementBlock("section", {
              key: 2,
              class: _normalizeClass(`${_ctx.isSP ? `` : ``} mt10`)
            }, [
              _createVNode(_component_MailEditDetailContent)
            ], 2))
          : _createCommentVNode("", true)
    ])
  ]))
}